<template>
  <div class="container-fluid">
    <div class="card glass-panel mb-4">
      <div class="card-body">
        <h3>Minha pauta</h3>
        <div class="dropdown-divider"></div>
        <h5>Aqui você visualiza a sua pauta de tickets.</h5>

        <div class="col-sm-12 p-0">
          <div class="table-responsive">
            <table class="table">
              <TableHeaders/>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {initGrid} from 'hennig-common'
import {approval, effective_approval, phase_dates, projection, dateTime, TableHeaders} from '../formmaters'

const collectionObj = 'Ticket'

const formatters = {
  combo (column, row) {
    if (row.type === 'Combo') {
      return '<span title="Ticket Combo" style="font-weight: bold;">C</span>'
    }
    return ''
  },
  effective_approval,
  approval,
  projection,
  phase_dates,
  dateTime,
  numPadding (column, row) {
    const combo = '<img height="12" class="mr-2" src="img/arrow-bottom-rigth.svg"/>'
    const parent = '<img height="12" class="mr-2" src="img/angle-double-right-solid.svg"/>'

    if (row.combo_ticket_id && row.parent_ticket_id) {
      return combo + parent + `<span>${row.num}</span>`
    }

    if (row.combo_ticket_id) {
      return combo + `<span>${row.num}</span>`
    }

    if (row.parent_ticket_id) {
      return parent + `<span>${row.num}</span>`
    }

    return row.num
  }
}
export default {
  name: 'TicketsAgenda',
  components: {
    TableHeaders
  },
  data () {
    return {
      search: {
        owner: 'my_user_id',
        status: ['Aberto'],
        agenda: true,
      },
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      initGrid({
        container: $(this.$el).find('table'),
        collectionObj,
        noAddButton: true,
        rowClick: true,
        search: () => this.search,
        bootgridParams: {
          rowCss (row) {
            let issubcombo = ''
            let isCombo = ''
            let rowStatus = row.status
            if (row.combo_ticket_id){
              issubcombo = ' row-subcombo '
            }

            if (row.type === 'Combo'){
              isCombo = 'row-combo'
            }

            if (row.combo_awaiting){
              isCombo = 'row-combo-awaiting'
            }

            if (row.status !== 'Aberto') {return ' entregue ' + issubcombo + ' ' + rowStatus}
            if (!row.approval_diff) {return issubcombo + ' ' + isCombo + ' ' + rowStatus}

            if(row.approval_diff){
              let diff = parseInt(row.approval_diff)
              const pos = ''
              return pos + issubcombo + ' ' + rowStatus + ' ' + isCombo
            }

            return ''
          }
        },
        formatters,
      })
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
    .table th:nth-child(6),
    .table th:nth-child(7),
    .table th:nth-child(8) {
        background-color: var(--surface-bg);
    }

    .th-phases {
        background-color: rgba(6, 182, 212, 0.15);
    }

    .a-menos {
        border-left: 20px solid #22c55e !important;
    }

    .no-prazo {
        border-left: 20px solid rgba(34, 197, 94, 0.4) !important;
    }

    .a-mais {
        background-color: rgba(239, 68, 68, 0.15) !important;
        border-left: 20px solid #ef4444 !important;
    }

    .Fechado, .Cancelado {
        border-left: 20px solid rgba(245, 158, 11, 0.4) !important;
    }

    .Aguardando {
        border-left: 20px solid rgba(99, 102, 241, 0.4) !important;
    }

    .badge.badge-light-primary {
        background-color: rgba(99, 102, 241, 0.15);
        color: var(--text-primary) !important;
        font-size: 11px;
        margin-top: 0.72rem;
    }

    .Aberto td:last-child {
        color: var(--text-primary) !important;
        font-weight: 600;
    }

    .Fechado td:last-child {
        color: #f59e0b !important;
        font-weight: 600;
    }

    .Cancelado td:last-child {
        color: #ef4444 !important;
        font-weight: 600;
    }

    .Aguardando td:last-child {
        color: #06b6d4 !important;
        font-weight: 600;
    }

    .row-combo .column-combo {
        background-color: #22c55e !important;
        color: white !important;
        text-align: center !important;
    }

    //.row-combo {
    //    background-color: rgba(6, 182, 212, 0.15);
    //}

    .row-combo-awaiting {
        background-color: var(--surface-panel);
        color: var(--text-primary);
    }

    .row-subcombo {
        //border-right: 20px solid rgba(6, 182, 212, 0.4) !important;
    }

    .table tr {
        border-top: 0px;
        border-bottom: 1px solid var(--border-color);
        transition: transform 0.2s ease;
        position: relative;
    }

    .table tr:hover {
        transform: translateY(-1px);
        box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
    }
}
</style>
